const keys = ['magic_drum', 'magic_drum_broken', 'torch', 'health_potion',
  'smoke_bomb', 'dwarven_dagger', 'magic_fiddle_bow', 'lantern',
  'rune_of_fire', 'rune_of_strength', 'rune_of_persuasion'] as const;
export type InventoryItemKeysType = typeof keys[number];
export const inventoryItemKeys: readonly InventoryItemKeysType[] = keys;

export const isInventoryItemKey = (s: string): s is InventoryItemKeysType =>
  inventoryItemKeys.indexOf(s as InventoryItemKeysType) !== -1;
